// schema/nodes/youtube.ts
import { HTMLBaseYoutube } from "../../db/HTMLBaseYoutube.js";
var YOUTUBE_SCHEMA = () => ({
  draggable: true,
  atom: true,
  isolating: true,
  group: "block",
  attrs: {
    data: { default: JSON.stringify(new HTMLBaseYoutube({}).toObject()) }
  },
  parseDOM: [
    {
      tag: "node-youtube",
      getAttrs(dom) {
        return {
          data: dom.getAttribute("data"),
          "no-content": "true"
        };
      }
    }
  ],
  toDOM: (node) => {
    return ["node-youtube", { data: node.attrs.data, "no-content": "true" }];
  }
});
var YOUTUBE_KEY = "youtube";
var YOUTUBE = {
  [YOUTUBE_KEY]: YOUTUBE_SCHEMA
};
export {
  YOUTUBE,
  YOUTUBE_KEY,
  YOUTUBE_SCHEMA
};
